import { useContext } from "react";
import { Context } from "../Reducers/Store";

export function usePermissao() {
  const [state] = useContext(Context);
  const permissoes = state.profile?.permissoes || [];

  /**
   * Verifica se o usuário tem uma permissão específica
   * @param {string} permissao - Código da permissão (ex: "usuarios.criar")
   */
  const tem = (permissao) => {
    return permissoes.includes(permissao);
  };

  /**
   * Verifica se o usuário tem pelo menos uma das permissões
   * @param {string[]} lista - Lista de códigos de permissão
   */
  const temAlguma = (lista) => {
    return lista.some(p => permissoes.includes(p));
  };

  /**
   * Verifica se o usuário tem todas as permissões
   * @param {string[]} lista - Lista de códigos de permissão
   */
  const temTodas = (lista) => {
    return lista.every(p => permissoes.includes(p));
  };

  /**
   * Verifica se o usuário pode visualizar um módulo
   * @param {string} modulo - Nome do módulo (ex: "usuarios", "acessosbd")
   */
  const podeVisualizarModulo = (modulo) => {
    return permissoes.some(p => p.startsWith(`${modulo}.`));
  };

  return {
    permissoes,
    tem,
    temAlguma,
    temTodas,
    podeVisualizarModulo,
  };
}